import { Integration } from '../../../../shared/interfaces/integration';
import { ObjectsConfig } from '../../../ObjectsConfiguration/components/ObjectsConfig/ObjectsConfig';

export function PipelineOverviewObjectsConfiguration({
  integration
}: {
  integration: Integration;
}) {
  return <ObjectsConfig integration={integration} isViewMode />;
}
